/**
 * FilterChips — Barra de filtros em chips/pills com seleção
 */
import { T } from '../../styles/tokens';

interface FilterChipsProps {
  options: Array<{ key: string; label: string; count?: number; color?: string }>;
  selected: string;
  onChange: (key: string) => void;
  size?: 'sm' | 'md';
}

export function FilterChips({ options, selected, onChange, size = 'md' }: FilterChipsProps) {
  const isSm = size === 'sm';
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      {options.map(opt => {
        const isActive = selected === opt.key;
        const accentColor = opt.color || T.primary;
        return (
          <button
            key={opt.key}
            onClick={() => onChange(opt.key)}
            style={{
              padding: isSm ? '4px 10px' : '6px 14px',
              borderRadius: 20,
              fontSize: isSm ? T.textXs : T.textSm,
              fontWeight: isActive ? T.weightSemibold : T.weightMedium,
              color: isActive ? accentColor : T.textSecondary,
              background: isActive ? `${accentColor}14` : 'transparent',
              border: `1px solid ${isActive ? `${accentColor}40` : T.border}`,
              cursor: 'pointer',
              transition: `all ${T.transitionFast}`,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            {opt.label}
            {opt.count != null && (
              <span style={{
                fontSize: T.textXs,
                color: isActive ? accentColor : T.textMuted,
                fontWeight: T.weightMedium,
              }}>
                {opt.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
